import { Button, notification } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const imageCommand =
  (entityId, entityType) =>
  ({ editor, range }) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      try {
        if (range) {
          editor.chain().focus().deleteRange(range).setCustomImage({ file, entityId, entityType }).run();
        } else {
          editor.chain().focus().setCustomImage({ file, entityId, entityType }).run();
        }
      } catch (error) {
        notification.error({
          message: 'Image Upload Failed',
          description: 'There was an error processing your image. Please try again or use a different image.',
          duration: 4,
        });
      }
    };
    input.click();
  };

const Image = ({ entityId, entityType, editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<PictureOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => imageCommand(entityId, entityType)({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="IMAGE" defaultMessage="Image" />
        </div>
      )}
    </Button>
  );
};

export default Image;
